"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
var _elementUi = require("element-ui");
var _api = require("../../../../api/api");
var _util = _interopRequireWildcard(require("../../../../assets/static/js/utils/util"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = exports.default = {
  data: function data() {
    return {
      showAppDialog: false,
      detailInfo: '' //详细信息
    };
  },
  mounted: function mounted() {
    this.getDetail();
  },
  computed: {
    city: function city() {
      if (this.detailInfo) {
        if (this.detailInfo.city && this.detailInfo.city.indexOf('全省') < 0) {
          return this.detailInfo.city.replace('市', '');
        } else {
          return this.detailInfo.province;
        }
      }
    }
  },
  methods: {
    subPicUrl: _util.subPicUrl,
    getDetail: function () {
      var _getDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var jsonParam, _yield$apiMallDetail, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              jsonParam = {
                jsonParamete: JSON.stringify({
                  fun: "merchantdetail",
                  param: {
                    merchantId: this.$route.query.merchantId
                  },
                  version: 1
                })
              };
              _context.next = 3;
              return (0, _api.apiMallDetail)(jsonParam);
            case 3:
              _yield$apiMallDetail = _context.sent;
              data = _yield$apiMallDetail.data;
              this.detailInfo = data.proData;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDetail() {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }()
  }
};